import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { dashboardStyles } from './dashboard-styles';

type EmptyStateProps = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void } | React.ReactNode;
  className?: string;
  compact?: boolean;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
  compact = false,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center",
        compact ? "py-8 px-4" : "py-14 px-4",
        className,
      )}
    >
      {icon && (
        <div className={dashboardStyles.emptyIcon}>
          {icon}
        </div>
      )}
      <p className={dashboardStyles.emptyTitle}>{title}</p>
      {description ? (
        <p className={dashboardStyles.emptyDescription}>{description}</p>
      ) : null}
      {action && !('type' in (action as object)) ? (
        <Button
          onClick={(action as { label: string; onClick: () => void }).onClick}
          size="sm"
          variant="outline"
          className="h-8 rounded-full px-4 text-xs font-semibold"
        >
          {(action as { label: string; onClick: () => void }).label}
        </Button>
      ) : (
        action as React.ReactNode
      )}
    </div>
  );
};

export default EmptyState;
